<template>
  <span
    id="cart-icon-badge-count"
    class="badge icon-badge"
    :class="{ 'is-hidden': itemCount === 0 }"
  >
    {{ itemCount }}
  </span>
</template>

<script>
import { mapState } from 'vuex';
import { flyoutCart } from './store';

export default {
  name: 'FlyoutCartBadge',
  computed: {
    ...mapState(flyoutCart, ['itemCount'])
  }
};
</script>
